import React from "react";

export const CreatorMusicRemoveMobileIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="12" fill="#fff" />
    <path
      d="M5 3.2V2h6V3.2h3V4.4H12.8v9a.6.6,0,0,1-.6.6H3.8a.6.6,0,0,1-.6-.6v-9H2V3.2ZM4.4,4.4v8.4h7.2V4.4ZM6.2,6.2H7.4V11H6.2Zm2.4,0H9.8V11H8.6Z"
      transform="translate(305 236) translate(-301 -232)"
      fill="#252525"
    />
  </svg>
);

export const CreatorMusicRemoveDesktopIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" {...props}>
    <ellipse cx="13.5" cy="14" rx="13.5" ry="14" fill="#181818" />
    <path
      d="M5.642,3.457V2h7.284V3.457h3.642V4.914H15.112V15.84a.728.728,0,0,1-.728.728H4.185a.728.728,0,0,1-.728-.728V4.914H2V3.457ZM4.914,4.914v10.2h8.741V4.914ZM7.1,7.1H8.556v5.827H7.1Zm2.914,0h1.457v5.827H10.013Z"
      transform="translate(3.875 4.703)"
      fill="#fff"
    />
  </svg>
);
